<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value | strToDate('P')"
        :label="label || $t('common.time.day')"
        :hint="hint"
        :persistent-hint="persistentHint"
        prepend-icon="mdi-calendar-range"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker :value="value" @input="dateChanged($event)"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ["value", "hint", "persistentHint", "label"],
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    dateChanged(event) {
      this.$emit("input", event);
      this.menu = false;
    },
  },
};
</script>
